import * as React from 'react';
import { useState, useEffect } from 'react';
import { Link } from 'gatsby';
import { getCookie, setCookie } from '../../Utils/Utils'

let classNames = require('classnames');

const NavLink = props => {
  const [isCodeExecuted, setCodeExecuted] = useState(false);

  useEffect(() => {
    if (!isCodeExecuted) {
      setCodeExecuted(true);
    }
  }, [isCodeExecuted]);
  return (

    <Link
      {...props}

      getProps={linkProps => {
        let pathName = linkProps.location.pathname;
        pathName = pathName[pathName.length - 1] === '/' ? pathName.slice(0, -1) : pathName;
        const current_path = pathName.length > 1 ? pathName.split('/').pop() : '/';
        const isCurrent = props.to === current_path;

        let prevPath = ""

        if (props.isactive == 'true') {
          return {
            className: classNames('active')
          };
        }

        if (props.to == '' || props.to == '/#') {
          return {
            className: classNames('no_link')
          };
        }

        if (props.match === 'exact') {

          if (isCodeExecuted) {
            prevPath = getCookie('currPath') //localStorage.getItem('currPath')


            //localStorage.setItem('prevPath', prevPath);
            setCookie('prevPath', prevPath, 180);
            //localStorage.setItem('currPath', current_path);
            setCookie('currPath', current_path, 180);

          }

          return {
            className: classNames('nav_lick', { 'active': isCurrent })
          };
        } else {
          return {
            //className: classNames('nav_lick', {'active' : isPartiallyCurrent})
          };
        }
      }}
    />
  );
};

export default NavLink;
